import React, { useState, useEffect } from 'react';
import PageLayout from '../common/PageLayout';
import { UpdateProductTableByCache, UpdateImageTableByCache } from '../utils/api/productApi';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import '../css/Step1.css';

function UpdateJPTableByCache() {
    const [error, setError] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [animatedText, setAnimatedText] = useState('Updating Database by Cache');
    const [serverLogs, setServerLogs] = useState([]);

    useEffect(() => {
        if (isConverting) {
            let currentIndex = 0;
            const fullText = 'Updating Database by Cache';
            const dots = '...';

            const timer = setInterval(() => {
                const numDots = (currentIndex % 4);  // 0에서 3까지 순환
                setAnimatedText(`${fullText}${dots.slice(0, numDots)}`);
                currentIndex++;
            }, 500);  // 타이머 간격을 500ms로 조정

            return () => clearInterval(timer);
        } else {
            setAnimatedText('Waiting...');  // converting 끝나면 원래 텍스트로
        }
    }, [isConverting]);

    const handleConvert = async () => {
        setError("");
        setStatusMessage("");
        setIsConverting(true);
        setServerLogs([]);

        const updateTasks = [
            { fn: () => UpdateProductTableByCache(), name: 'Product Table', title: '=== Product Table Update Result ===' },
            { fn: () => UpdateImageTableByCache(), name: 'Image Table', title: '=== Image Table Update Result ===' }
        ];

        try {
            for (const task of updateTasks) {
                const result = await handleImportProcess(task.fn, task.name);
                if (!result.success) {
                    setStatusMessage(`Fail to Update ${task.name}: ${result.message}`);
                    return;
                }

                const logs = Array.isArray(result.data.details)
                    ? result.data.details
                    : [result.data.details];

                setServerLogs(prevLogs => [
                    ...prevLogs,
                    task.title,
                    ...logs,
                    ""  // 구분을 위한 빈 줄
                ]);
            }

            setStatusMessage("All updates are successfully completed.");
        } catch (error) {
            console.error('Error:', error);
            setError('Fail to Update Database by Cache.');
            setStatusMessage('Update Failed.');
        } finally {
            setIsConverting(false);
        }
    };


    return (
        <PageLayout
            title="Update Database by Cache"
            description={
                <p className={`animated-text ${isConverting ? 'converting' : ''}`}>
                    {animatedText}
                </p>
            }
            onSubmit={handleConvert}
            isFileUpload={false}
            error={error}
            statusMessage={statusMessage}
            submitButtonText={isConverting ? "Updating..." : "Update"}
        >
            {/* children으로 서버 로그를 전달 */}
            {serverLogs.length > 0 && (
                <div className="server-logs-container">
                    <h3>서버 로그</h3>
                    <div className="server-logs">
                        {serverLogs.map((log, index) => (
                            <div key={index} className="log-line">
                                {log}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </PageLayout>
    );
}

export default UpdateJPTableByCache;